import { StateCreator } from 'zustand'

import { QueryParamsState } from './types'

export const createQueryParamsStateSlice: StateCreator<
  QueryParamsState,
  [],
  [],
  QueryParamsState
> = (set) => ({
  utmCampaign: '',
  queryParams: '',
  probability: '',

  setUtmCampaign: (utmCampaign) => set(() => ({ utmCampaign })),
  setQueryParams: (queryParams) => set(() => ({ queryParams })),
  setProbability: (probability) => set(() => ({ probability })),
  resetUtmCampaign: () => set(() => ({ utmCampaign: '' })),
  resetQueryParams: () => set(() => ({ queryParams: '' })),
  resetProbability: () => set(() => ({ probability: '' })),
})
